import React from 'react'
// @src imports
import SOCImages from 'src/editor/images/SOCImages'
import FacebookImages from 'src/editor/components/FacebookImages/FacebookImages'
import { useState } from 'src/hooks'
// relative imports
import ScaleSlider from './ScaleSlider'
import TextBarMobile from './TextBarMobile/TextBarMobile'

import { Api } from '../api'
import { Steps } from '../types'
import styles from './MinimalTextOptions/minimalTextOptions.module.scss'
import drawerStyle from '../styles/components/Drawer.module.scss'

const items = [
  {
    name: 'Images' as const,
    icon: 'PHOTOS' as const,
    size: 18,
  },
  {
    name: 'Scale' as const,
    icon: 'EQUALIZER' as const,
    size: 18,
  },
  {
    name: 'Remove' as const,
    icon: 'TRASH' as const,
    size: 18,
  },
]

type Props = {
  api: Api & { step: { type: Steps.EditPicture | Steps.EditBackgroundPicture } }
}

type Control = 'Images' | 'Scale' | 'Remove'

const MinimalImageOptions: React.FC<Props> = props => {
  const { api } = props
  const {
    removePicture,
    step,
    editPicture,
    removeBackgroundPicture,
    updateElementImage,
    editBackgroundPicture,
    getSelectedElement,
  } = api

  const [tool, setTool] = useState<Control>('Images')

  const handleControlClicked = (control: Control | 'Close') => {
    switch (control) {
      case 'Remove':
        setTool('Images')
        switch (step.type) {
          case Steps.EditPicture:
            removePicture(
              step.fullBleedIndex,
              step.panelIndex,
              step.elementIndex,
            )
            break
          case Steps.EditBackgroundPicture:
            removeBackgroundPicture(step.fullBleedIndex)
            break
        }
        break
      case 'Close':
        break
      case 'Images':
        setTool('Images')
        break
      case 'Scale':
        setTool('Scale')
        break
    }
  }

  const imageScale = getSelectedElement(step)?.image?.scale || 1

  const setScale = (scale: number) => {
    if (step.type === Steps.EditPicture) {
      updateElementImage(
        step.fullBleedIndex,
        step.panelIndex,
        step.elementIndex,
        image => ({
          ...image,
          scale,
          position: api.getCorrectedImagePosition(scale, image.position),
        }),
      )
    }
  }

  const onEdit = (source: 'own' | 'social') => {
    switch (step.type) {
      case Steps.EditPicture:
        editPicture(
          step.fullBleedIndex,
          step.panelIndex,
          step.elementIndex,
          source,
        )
        break
      case Steps.EditBackgroundPicture:
        editBackgroundPicture(step.fullBleedIndex, source)
        break
    }
  }

  return (
    <div className={tool === 'Images' ? '' : styles.minimalTextBar}>
      <TextBarMobile
        tool={tool}
        onClick={handleControlClicked}
        items={items}
        style={{ position: 'initial' }}
      />
      <div style={{ height: '100%' }}>
        {tool === 'Images' && (
          <div>
            <nav className={drawerStyle.imagePanelNav}>
              <li
                className={step.source === 'own' && drawerStyle.selected}
                onClick={() => onEdit('own')}
              >
                My Images
              </li>
              <li
                className={step.source === 'social' && drawerStyle.selected}
                onClick={() => onEdit('social')}
              >
                Social Media
              </li>
            </nav>
            {step.source === 'own' && <SOCImages api={api} />}
            {step.source === 'social' && <FacebookImages api={api} />}
          </div>
        )}
        {step.type === Steps.EditPicture && tool === 'Scale' && (
          <div
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              paddingBottom: 38,
            }}
          >
            <ScaleSlider
              scale={imageScale}
              onChange={scale => setScale(scale)}
              isMobile={true}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default MinimalImageOptions
